import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from '@tanstack/react-router'
import { Container } from '../../../components/layout/container'
import { Button, Card, Flex, Form, Input, Steps } from 'antd'
import { DetailsStep } from './steps/details-step'
import { WhatsappSetupStep } from './steps/whatsapp-step'
import { TryStep } from './steps/try-step'
import { useCreateCampaignStepsContext } from './campaign-create-steps-context'
import { LinkStep } from './steps/link-step'
import { TypeStep } from './steps/type-step'
import { useAuth } from '../../../auth'
import { INDEX_MESSAGE_TEMPLATE, INDEX_PHONE_NUMBERS, INDEX_WHATSAPP_BUSINESS_ACCOUNT } from '../../../user/permission'
import { FormItem } from '../../../components/form-item'
import { StoreInput } from '../../input/store-input'

export function CampaignCreateSteps() {
    const { steps, formProps, current, initialValues, openStep } = useCreateCampaignStepsContext()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { can } = useAuth()
    const hasWhatsappPermissions = can([INDEX_WHATSAPP_BUSINESS_ACCOUNT, INDEX_PHONE_NUMBERS, INDEX_MESSAGE_TEMPLATE])

    return (
        <Container className="pb-8 md:pb-12 md:max-w-[900px]">
            <Card
                className="rounded-3xl overflow-hidden"
                styles={{
                    body: {
                        padding: 0,
                    },
                }}
            >
                <Flex className="bg-primary flex-col-reverse md:flex-row">
                    <Form
                        {...formProps}
                        initialValues={initialValues}
                        layout="vertical"
                        className="w-full p-8 md:p-12 bg-white"
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' && event.target instanceof HTMLInputElement) {
                                event.preventDefault()
                            }
                        }}
                    >
                        <TypeStep />
                        <DetailsStep />
                        {hasWhatsappPermissions ? (
                            <WhatsappSetupStep />
                        ) : (
                            <div className="hidden">
                                <FormItem<StoreInput> name="whatsappBusinessAccountId">
                                    <Input hidden />
                                </FormItem>

                                <FormItem<StoreInput> name="phoneNumberId">
                                    <Input hidden />
                                </FormItem>

                                <FormItem<StoreInput> name="startMessageTemplateId">
                                    <Input hidden />
                                </FormItem>
                            </div>
                        )}
                        <TryStep />
                        <LinkStep />
                    </Form>
                    <div className="min-w-[330px] p-8 pt-6 pb-2 md:pt-24 md:p-16">
                        <Steps
                            current={current}
                            progressDot
                            direction="vertical"
                            className="text-white onboard-steps"
                            items={steps}
                            onChange={openStep}
                        />
                        <Button
                            type="link"
                            className="text-white px-0 mt-4"
                            onClick={() => navigate({ to: '/campaigns' })}
                        >
                            {t('Cancel')}
                        </Button>
                    </div>
                </Flex>
            </Card>
        </Container>
    )
}
